export let routes = [
  {
    path: '/x3-side-ceping-filtrate',
    name: 'x3-side-ceping-filtrate',
    component: () => import('@x3/js/side/ceping/ceping-filtrate.vue'),
    meta: {
      vx_animate: 'none',
    },
  },{
    path: '/x3-side-ceping-item-filtrate',
    name: 'x3-side-ceping-item-filtrate',
    component: () => import('@x3/js/side/ceping/ceping-item-filtrate.vue'),
    meta: {
      vx_animate: 'none',
    },
  },{
    path: '/x3-side-ceping-tpl-filtrate',
    name: 'x3-side-ceping-tpl-filtrate',
    component: () => import('@x3/js/side/ceping/ceping-tpl-filtrate.vue'),
    meta: {
      vx_animate: 'none',
    },
  },{
    path: '/x3-side-ceping-category-filtrate',
    name: 'x3-side-ceping-category-filtrate',
    component: () => import('@x3/js/side/ceping/ceping-category-filtrate.vue'),
    meta: {
      vx_animate: 'none',
    },
  }
];

export let api = {
  xsCepingFiltrate(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-ceping-filtrate',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsCepingItemFiltrate(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-ceping-item-filtrate',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsCepingTplFiltrate(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-ceping-tpl-filtrate',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsCepingCategoryFiltrate(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-ceping-category-filtrate',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};